import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { FaEye, FaEyeSlash } from 'react-icons/fa';

import '../../src/App.css';
import '../css/Login.css';

const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Login - Construction and Engineering";  // Set the page title
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
          metaDescription.setAttribute("content", "Login to your Construction and Engineering Saudi Arabia account.");
        }

        // Add the 'login-body' class to the body
        document.body.classList.add('login-body');

        // Cleanup: Remove the 'login-body' class when the component unmounts
        return () => {
            document.body.classList.remove('login-body');
        };
      }, []);
    

    const handleSubmit = (event) => {
        event.preventDefault();
        if (username === 'admin' && password === 'admin') {
            console.log('Login successful');
            navigate('/dashboard'); // Navigate to the dashboard
        } else {
            console.log('Invalid username or password');
            alert('Invalid credentials');
        }
    };

    return (
        <div className="login-container">
            <div className='top'>
                <img src="/images/logo.png" alt="Logo" />
                <h1>Did you forgot your password?</h1>
                <label className="login-subtext">
                    Enter your email address you're using for your account below and we will send you a password reset link
                </label>
            </div>
            <form onSubmit={handleSubmit}>
                <label htmlFor="email" className="input-label">
                    Email Address
                </label>
                <input
                    type="text"
                    placeholder="myemail@address.com"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                />

                <button type="submit">Request Reset Link</button>
            </form>
            <a href="/">Back to Sign in?</a>
        </div>
    );
};

export default Login;
